/**
 * Memory Data Sovereignty Tab
 *
 * User controls for data export, selective wipe, and privacy settings.
 */
import { useState } from 'react'
import { Card, Button } from '@personic/shared'
import { Download, Trash2, Shield } from 'lucide-react'

export function MemorySovereignty() {
  const [exportLoading, setExportLoading] = useState(false)

  return (
    <div className="space-y-6">
      {/* Export */}
      <Card className="p-6 bg-neutral-900/50 border-neutral-800">
        <div className="flex items-center gap-3 mb-4">
          <Download className="h-5 w-5 text-blue-400" />
          <h3 className="text-lg font-semibold text-white">Export Data</h3>
        </div>
        <p className="text-sm text-neutral-400 mb-4">
          Download a complete copy of your memory data including episodes,
          semantic nodes, and procedural patterns.
        </p>
        <Button
          variant="outline"
          disabled={exportLoading}
          onClick={() => setExportLoading(true)}
          className="border-neutral-600"
        >
          {exportLoading ? 'Preparing export...' : 'Export as JSON'}
        </Button>
      </Card>

      {/* Privacy Controls */}
      <Card className="p-6 bg-neutral-900/50 border-neutral-800">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="h-5 w-5 text-green-400" />
          <h3 className="text-lg font-semibold text-white">Privacy Controls</h3>
        </div>
        <div className="space-y-3">
          <div className="flex items-center justify-between py-2">
            <div>
              <p className="text-sm text-white">Cross-lens sharing</p>
              <p className="text-xs text-neutral-500">Allow memory to be shared between Identity and Engage</p>
            </div>
            <span className="text-xs text-neutral-400 bg-neutral-800 px-2 py-1 rounded">Disabled</span>
          </div>
          <div className="flex items-center justify-between py-2">
            <div>
              <p className="text-sm text-white">Auto-redact PII</p>
              <p className="text-xs text-neutral-500">Automatically redact personally identifiable information</p>
            </div>
            <span className="text-xs text-neutral-400 bg-neutral-800 px-2 py-1 rounded">Disabled</span>
          </div>
        </div>
      </Card>

      {/* Danger Zone */}
      <Card className="p-6 bg-neutral-900/50 border-red-900/30">
        <div className="flex items-center gap-3 mb-4">
          <Trash2 className="h-5 w-5 text-red-400" />
          <h3 className="text-lg font-semibold text-red-400">Danger Zone</h3>
        </div>
        <p className="text-sm text-neutral-400 mb-4">
          Permanently delete your memory data. This action cannot be undone.
        </p>
        <div className="flex gap-3">
          <Button variant="outline" className="border-red-800 text-red-400 hover:bg-red-900/20">
            Wipe Episodes
          </Button>
          <Button variant="outline" className="border-red-800 text-red-400 hover:bg-red-900/20">
            Wipe All Memory
          </Button>
        </div>
      </Card>
    </div>
  )
}
